export default "__VITE_ASSET__79ec16a1__"